import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12.5, cy: 12, r: 12, fill: "#BDC0D0" }), /* @__PURE__ */ React.createElement("path", { d: "M17.1666 12.6666H13.1666V16.6666H11.8333V12.6666H7.83325V11.3333H11.8333V7.33325H13.1666V11.3333H17.1666V12.6666Z", fill: "white" }));
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
